import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormGroup, Validators, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as i2 from 'app-services-library';
import * as i4 from 'custom-dropdown';
import * as i6 from '@angular/router';
import * as i7 from '@angular/common';
import { PrimengLibraryModule } from 'primeng-library';

class CustomChipService {
    constructor() {
        this.initialChips = [];
        this.chipsArrayModified = false;
    }
    setInitialChips(chips) {
        this.initialChips = chips;
    }
    getInitialChips() {
        return this.initialChips;
    }
    setChipsArrayModified(modified) {
        this.chipsArrayModified = modified;
    }
    getChipsArrayModified() {
        return this.chipsArrayModified;
    }
}
CustomChipService.ɵfac = function CustomChipService_Factory(t) { return new (t || CustomChipService)(); };
CustomChipService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomChipService, factory: CustomChipService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomChipService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CustomChipComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵlistener("click", function CustomChipComponent_div_3_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r6); const i_r4 = ctx.index; const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.removeChip(i_r4); });
    i0.ɵɵtext(2, "\u00D7");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.isDisabled ? "disableCross" : "");
} }
function CustomChipComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, " Required");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} }
function CustomChipComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵelementStart(1, "span", 7);
    i0.ɵɵtext(2, "Only Email Format is Allowed");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0, a1) { return { "width": a0, "height": a1 }; };
class CustomChipComponent {
    constructor(fb, appServicesLibraryService, cd, store, customDropdownService, customChipService, route) {
        this.fb = fb;
        this.appServicesLibraryService = appServicesLibraryService;
        this.cd = cd;
        this.store = store;
        this.customDropdownService = customDropdownService;
        this.customChipService = customChipService;
        this.route = route;
        this.group = new FormGroup({});
        this.mycontrol = '';
        this.observableSubscription$ = new Subject();
        this.isDisabled = false;
        this.initialChips = [];
    }
    ngOnInit() {
        var _a;
        this.userType = sessionStorage.getItem('userTypeRole');
        this.inputParams.placeholder = this.inputParams.placeholder || '';
        this.inputParams.value = this.inputParams.value || [];
        function notEmpty(value) {
            return value !== null && value !== undefined;
        }
        if (this.inputParams.enableAutoFill == true) {
            let selecteduser = this.stringIsArray(sessionStorage.getItem('toClientEmail'));
            /*  selecteduser = typeof selecteduser === 'object' ? JSON.parse(selecteduser) as any[] : selecteduser;
             */
            this.inputParams.value = this.inputParams.value.filter(notEmpty);
            if (selecteduser) {
                let emails = JSON.parse(sessionStorage.getItem('toClientEmail'));
                emails.forEach(item => {
                    this.inputParams.value = [...this.inputParams.value, item.email];
                });
            }
            else {
                let email = sessionStorage.getItem('toClientEmail');
                this.inputParams.value = [...this.inputParams.value, email];
            }
        }
        if (this.inputParams.stepName && this.inputParams.stepName == 'Send Receipt') {
            this.inputParams.value = [];
        }
        const chipFieldValidators = this.inputParams.mandatory ? [Validators.required] : [];
        if (this.inputParams.isEmailFormatOnly) {
            chipFieldValidators.push((control) => {
                const inputVal = control.value;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const valid = control.value.every((chip) => emailRegex.test(chip.trim()));
                return valid ? null : { invalidEmail: true };
            });
        }
        this.group.addControl(this.inputParams.name, this.fb.control(this.inputParams.value, chipFieldValidators));
        let savedValue;
        this.route.queryParams.subscribe(params => {
            const stepParameter = params['step'];
            if (!stepParameter) {
                savedValue = this.customDropdownService.clearFormValue(this.inputParams.name);
                this.customChipService.setChipsArrayModified(false);
            }
            else {
                savedValue = this.customDropdownService.getFormValue(this.inputParams.name);
            }
        });
        this.subscription = this.customDropdownService
            .getEmails()
            .subscribe((chips) => {
            this.chipsArrayModified = this.isChipsArrayModified(chips);
            if (savedValue && this.chipsArrayModified) {
                savedValue.length = 0;
            }
            if (!savedValue || savedValue.length === 0) {
                this.initialChips = chips;
                this.customChipService.setInitialChips(this.initialChips);
                if (this.chipsArrayModified || this.inputParams.name === "generateReceiptChip") {
                    chips.forEach(value => {
                        const addEvent = { target: { value } };
                        this.addChip(addEvent);
                    });
                }
                this.chipsArrayModified = false;
            }
        });
        const formControl = this.group.get(this.inputParams.name);
        if (savedValue && formControl && !this.chipsArrayModified) {
            savedValue.forEach(value => {
                const addEvent = { target: { value } };
                this.addChip(addEvent);
            });
        }
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.chipComponentEnableDisable();
            });
        }
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    stringIsArray(str) {
        try {
            return new Function(`return Array.isArray(${str})`)();
        }
        catch (_a) {
            return false;
        }
    }
    chipComponentEnableDisable() {
        var _a, _b, _c;
        if (((this.userType == "Petitioner" || this.userType == "Attorney") && ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepStatusCode) == "COMPLETE") || (this.userType == "Beneficiary" && (((_b = this.inputData) === null || _b === void 0 ? void 0 : _b.stepStatusCode) == "COMPLETE" || ((_c = this.inputData) === null || _c === void 0 ? void 0 : _c.stepStatusCode) == "SUBMIT"))) {
            this.group.disable();
            this.isDisabled = true;
            this.cd.detectChanges();
        }
        else {
            this.group.enable();
            this.isDisabled = false;
            this.cd.detectChanges();
        }
    }
    isChipsArrayModified(newChips) {
        var _a;
        this.initialChips = this.customChipService.getInitialChips();
        const isChipRemoved = this.customChipService.getChipsArrayModified();
        let isDDModified = this.customDropdownService.getEmailsChanged();
        const sortedInitialChips = (_a = this.initialChips) === null || _a === void 0 ? void 0 : _a.slice().sort();
        const sortedNewChips = newChips === null || newChips === void 0 ? void 0 : newChips.slice().sort();
        if (sortedInitialChips.length !== sortedNewChips.length) {
            return true;
        }
        if (this.inputParams.name === "generateReceiptChip") {
            isDDModified = false;
        }
        for (let i = 0; i < sortedNewChips.length; i++) {
            if (sortedInitialChips[i] !== sortedNewChips[i]) {
                return true;
            }
        }
        if (isDDModified || (isDDModified && isChipRemoved)) {
            return true;
        }
        return false;
    }
    addChip(e) {
        var _a;
        const inputValue = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.trim();
        if (inputValue && inputValue !== "") {
            if (e.target.value.includes(",")) {
                let spliceComma = e.target.value.split(',');
                this.inputParams.value = [...this.inputParams.value, spliceComma[0]];
            }
            else {
                this.inputParams.value = [...this.inputParams.value, e.target.value];
            }
            this.customDropdownService.setFormValue(this.inputParams.name, this.inputParams.value);
            this.group.controls[this.inputParams.name].setValue(this.inputParams.value);
            this.group.controls[this.inputParams.name].updateValueAndValidity();
            this.group.controls[this.inputParams.name].markAsTouched();
        }
        e.target.value = ' ';
        ``;
    }
    removeChip(index) {
        this.inputParams.value.splice(index, 1);
        this.group.controls[this.inputParams.name].setValue(this.inputParams.value);
        this.customChipService.setChipsArrayModified(true);
        this.group.controls[this.inputParams.name].updateValueAndValidity();
        this.group.controls[this.inputParams.name].markAsTouched();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
CustomChipComponent.ɵfac = function CustomChipComponent_Factory(t) { return new (t || CustomChipComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.AppServicesLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.CustomDropdownService), i0.ɵɵdirectiveInject(CustomChipService), i0.ɵɵdirectiveInject(i6.ActivatedRoute)); };
CustomChipComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomChipComponent, selectors: [["custom-chip"]], inputs: { inputParams: "inputParams", group: "group", inputData: "inputData", formControlName: "formControlName" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 10, vars: 13, consts: [[3, "formGroup"], [1, "chip-container", 2, "height", "150px", "overflow", "auto", 3, "formGroupName"], [1, "chip-tag-container"], ["class", "chip-tag", 4, "ngFor", "ngForOf"], ["type", "text", 1, "chip-input", 3, "placeholder", "keyup.,", "blur", "keyup.enter"], ["class", "error", 4, "ngIf"], [1, "subtitle"], [1, "common-bene-class-for-translation"], [1, "chip-tag"], ["aria-hidden", "true", 1, "chip-cross-icon", 3, "ngClass", "click"], [1, "error"]], template: function CustomChipComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, CustomChipComponent_div_3_Template, 3, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 4);
        i0.ɵɵlistener("keyup.,", function CustomChipComponent_Template_input_keyup___4_listener($event) { return ctx.addChip($event); })("blur", function CustomChipComponent_Template_input_blur_4_listener($event) { return ctx.addChip($event); })("keyup.enter", function CustomChipComponent_Template_input_keyup_enter_4_listener($event) { return ctx.addChip($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, CustomChipComponent_span_5_Template, 3, 0, "span", 5);
        i0.ɵɵtemplate(6, CustomChipComponent_span_6_Template, 3, 0, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "span", 7);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_6_0 = null;
        let tmp_7_0 = null;
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction2(10, _c0, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.height));
        i0.ɵɵproperty("formGroupName", ctx.formControlName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.inputParams == null ? null : ctx.inputParams.value);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("placeholder", ctx.inputParams == null ? null : ctx.inputParams.placeholder);
        i0.ɵɵattribute("disabled", ctx.isDisabled ? "disabled" : null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ((tmp_6_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : tmp_6_0.touched) && ((tmp_6_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : tmp_6_0.hasError("required")));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.isEmailFormatOnly) && ((tmp_7_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : tmp_7_0.touched) && ((tmp_7_0 = ctx.group.get(ctx.inputParams.name)) == null ? null : tmp_7_0.hasError("invalidEmail")));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.inputParams == null ? null : ctx.inputParams.subText);
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormGroupName, i7.NgForOf, i7.NgIf, i7.NgClass], styles: [".chip-container[_ngcontent-%COMP%]{width:300px;padding:5px;border:1px solid #cecece;border-radius:5px;background:#fff}.chip-container[_ngcontent-%COMP%]   .chip-tag-container[_ngcontent-%COMP%]{width:93%;margin:0 auto}.chip-container[_ngcontent-%COMP%]   .chip-tag-container[_ngcontent-%COMP%]   .chip-tag[_ngcontent-%COMP%]{padding:3px 12px;background:#d1edff;border:1px solid #879ead;color:#000;font-size:12px;border-radius:5px;margin:8px 8px 0 0;min-width:70px;float:left;font-weight:700;display:flex;justify-content:space-between}.chip-container[_ngcontent-%COMP%]   .chip-tag-container[_ngcontent-%COMP%]   .chip-tag[_ngcontent-%COMP%]   .chip-text[_ngcontent-%COMP%]{display:flex;align-items:center}.chip-container[_ngcontent-%COMP%]   .chip-tag-container[_ngcontent-%COMP%]   .chip-tag[_ngcontent-%COMP%]   .chip-cross-icon[_ngcontent-%COMP%]{font-size:20px;width:10%;cursor:pointer}.chip-container[_ngcontent-%COMP%]   .chip-input[_ngcontent-%COMP%]{width:93%;border:1px solid #cecece;padding:8px;margin:10px}.title[_ngcontent-%COMP%]{font-size:14px}.error[_ngcontent-%COMP%], .subtitle[_ngcontent-%COMP%]{font-size:12px}.error[_ngcontent-%COMP%]{color:#e31302;padding-top:3px}.disableCross[_ngcontent-%COMP%]{pointer-events:none;cursor:default;text-decoration:none}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomChipComponent, [{
        type: Component,
        args: [{
                selector: 'custom-chip',
                templateUrl: 'custom-chip.component.html',
                styleUrls: ['custom-chip.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.AppServicesLibraryService }, { type: i0.ChangeDetectorRef }, { type: i3.Store }, { type: i4.CustomDropdownService }, { type: CustomChipService }, { type: i6.ActivatedRoute }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], inputData: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class CustomChipModule {
}
CustomChipModule.ɵfac = function CustomChipModule_Factory(t) { return new (t || CustomChipModule)(); };
CustomChipModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomChipModule });
CustomChipModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            PrimengLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomChipModule, { declarations: [CustomChipComponent], imports: [FormsModule,
        ReactiveFormsModule,
        PrimengLibraryModule], exports: [CustomChipComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomChipModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomChipComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    PrimengLibraryModule,
                ],
                exports: [CustomChipComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-chip
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomChipComponent, CustomChipModule, CustomChipService };
//# sourceMappingURL=custom-chip.js.map
